"use client";

import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { FiMenu, FiX } from "react-icons/fi";
import styles from "./NavBar.module.css";
import logo from "@/../public/images/logo.png"; // adjust path if needed

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => setIsOpen(!isOpen);

    return (
        <nav className={styles.navbar}>
            {/* Logo */}
            <div className={styles.navbarLogo}>
                <Link href="https://vgenomics.in/" target="_blank">
                    <Image
                        src={logo}
                        alt="VGenomics Logo"
                        width={250}
                        height={41}
                        priority
                    />
                </Link>
            </div>

            {/* Desktop Links */}
            <ul className={styles.navbarLinks}>
                <li><Link href="https://vgenomics.in/company/" target="_blank">Company</Link></li>
                <li><Link href="https://vgenomics.in/solutions/" target="_blank">Solutions</Link></li>
                <li><Link href="https://vgenomics.in/our-science/" target="_blank">Our Science</Link></li>
                <li><Link href="https://vgenomics.in/patients/" target="_blank">Patients</Link></li>
                <li><Link href="https://vgenomics.in/careers/" target="_blank">Careers</Link></li>
                <li><Link href="https://vgenomics.in/company/#enquiry" target="_blank">Contact Us</Link></li>
            </ul>

            {/* Hamburger Icon (Mobile only) */}
            <div className={styles.navbarMenuIcon} onClick={toggleMenu}>
                {isOpen ? <FiX size={28} /> : <FiMenu size={28} />}
            </div>

            {/* Sidebar Menu (Mobile) */}
            <div className={`${styles.sidebar} ${isOpen ? styles.open : ""}`}>
                <ul>
                    <li>
                        <Link href="https://vgenomics.in/company/" target="_blank" onClick={toggleMenu}>
                            Company
                        </Link>
                    </li>
                    <li>
                        <Link href="https://vgenomics.in/solutions/" target="_blank" onClick={toggleMenu}>
                            Solutions
                        </Link>
                    </li>
                    <li>
                        <Link href="https://vgenomics.in/science/" target="_blank" onClick={toggleMenu}>
                            Our Science
                        </Link>
                    </li>
                    <li>
                        <Link href="https://vgenomics.in/patients/" target="_blank" onClick={toggleMenu}>
                            Patients
                        </Link>
                    </li>
                    <li>
                        <Link href="https://vgenomics.in/careers/" target="_blank" onClick={toggleMenu}>
                            Careers
                        </Link>
                    </li>
                    <li>
                        <Link href="https://vgenomics.in/company/#enquiry" target="_blank" onClick={toggleMenu}>
                            Contact Us
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
